import React from "react";
import { Area, AreaChart, ResponsiveContainer } from "recharts";
import { colors2 } from "oolib";

/**
 * Decorative area sparkline for the overview cards. The line + fill fade in
 * left → right (horizontal gradient) so older points recede and the latest
 * trend reads strongest, matching the card background treatment.
 *
 * @param data    [{ count } | { value }, …]; labels are ignored (no axes).
 * @param color   stroke/fill base colour (defaults to grey40).
 * @param height  chart height; defaults to "100%" so it fills its wrapper.
 */
export function Sparkline({ data = [], color, height = "100%" }) {
  const points = (data || []).map((d, i) => ({ i, value: (d.count ?? d.value ?? 0) + 0.2 }));
  if (points.length < 2) return null;

  const base = color || colors2.grey40;
  // useId can emit ":" which is invalid inside url(#…) refs — strip it.
  const uid = React.useId().replace(/:/g, "");
  const strokeId = `spark-stroke-${uid}`;
  const fillId = `spark-fill-${uid}`;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={points} margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id={strokeId} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor={base} stopOpacity={0} />
            <stop offset="100%" stopColor={base} stopOpacity={0.9} />
          </linearGradient>
          <linearGradient id={fillId} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor={base} stopOpacity={0} />
            <stop offset="100%" stopColor={base} stopOpacity={0.18} />
          </linearGradient>
        </defs>
        <Area
          type="linear"
          dataKey="value"
          stroke={`url(#${strokeId})`}
          strokeWidth={2}
          fill={`url(#${fillId})`}
          isAnimationActive={false}
          dot={false}
          activeDot={false}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}

export default Sparkline;
